<template>
  <section>
    <div class="inner">
      <Title class="section-title">
        <template #title>
          <router-link to="/202008/channel">
            リトル・ママチャンネル
          </router-link>
        </template>
      </Title>
      <ChannelProgram
        :program="getProgram()"
        :onair="nowOnair"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Title from '@/components/atoms/Title.vue'
import ChannelProgram from '@/components/molecules/ChannelProgram.vue'

export default {
  components: {
    Title,
    ChannelProgram
  },
  data: () => ({
    opening: {
      thumbnail: '/img/channel08/opening.png',
      title: '当日10:00 みんな集合オープニング',
      start: '',
      end: '',
      link: 'https://www.instagram.com/littlemama_official/'
    },
    ending: {
      thumbnail: '/img/channel08/ending.png',
      title: '抽選会＆最優秀コンテンツ賞発表',
      start: '',
      end: '',
      link: 'https://www.instagram.com/littlemama_official/'
    },
    nowOnair: false
  }),
  computed: {
    ...mapGetters('channels202008', [
      'onair',
      'next'
    ]),
    now () {
      return this.$moment()
    }
  },
  methods: {
    getProgram () {
      if (this.now.isBefore('2020-08-27')) {
        return this.opening
      } else if (this.now.isAfter('2020-08-27', 'day')) {
        return this.ending
      } else {
        if (this.onair) {
          this.nowOnair = true
          return this.onair
        } else if (this.next) {
          return this.next
        }
      }
      return this.ending
    }
  }
}
</script>

<style lang="sass" scoped>
/deep/ .section-title
  justify-content: space-between
  margin-bottom: 15px
  a
    color: $green
    text-decoration: underline
</style>
